import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LegalAcceptanceGateComponent } from './components/legal-acceptance-gate/legal-acceptance-gate.component';

@Component({
  imports: [RouterModule, LegalAcceptanceGateComponent],
  selector: 'app-root',
  template: `
    <router-outlet />
    <app-legal-acceptance-gate />
  `,
  styles: [],
})
export class App {}
